// extracted by mini-css-extract-plugin
export var buttonContainer = "_9c-1";
export var fontSizeSelect = "_9c-3";
export var formatSelect = "_9c-2";
export var formats = "_9c-4";
export var hidden = "_9c-5";
export var icon = "_9c-6";
export var select = "_9c-0";